module.exports = __webpack_public_path__ + "static/media/eas.beb73534.svg";